<template>
  <div>
    <OrderPreviewModal />
  </div>
</template>
<script>
import OrderPreviewModal from "@/components/widgets/Modals/OrderPreviewModal";
export default {
  name: "BarcodeOrdersActions",
  components: {
    OrderPreviewModal
  }
};
</script>

